"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ImageCard = _interopRequireDefault(require("../block/ImageCard"));
var _AdjustableTwoColumnGrid = _interopRequireDefault(require("../layout-wrappers/AdjustableTwoColumnGrid"));
var _Concat = _interopRequireDefault(require("../utils/Concat"));
var _StringList = _interopRequireDefault(require("../utils/StringList"));
var _helpers = require("./../../utils/helpers");
var _ShowAboutLayoutModule = _interopRequireDefault(require("./../../scss/layouts/ShowAboutLayout.module.scss"));
var _ShowAboutContent = _interopRequireDefault(require("./ShowAboutContent"));
function ShowAboutLayout({
  series,
  type = 'series',
  showUpcoming = false,
  nextAirdates = [],
  firstColumnWidth = '33%'
}) {
  var _series$detailImage, _series$detailImage2;
  const castStr = series.cast.map(cast => cast.real_name).join(', ');
  const ratingAndTime = type === 'series' ? [`TV Series`, series.rating] : [series !== null && series !== void 0 && series.year_released ? series === null || series === void 0 ? void 0 : series.year_released : `Film`, series.rating];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_AdjustableTwoColumnGrid.default, {
    classname: (0, _helpers.classes)([_ShowAboutLayoutModule.default['series-about-tab'], 'series-about-tab']),
    firstColumnWidth: firstColumnWidth
  }, series.detailImage === null ? /*#__PURE__*/_react.default.createElement(_Concat.default, {
    list: [typeof series.genres === 'string' ? series.genres : /*#__PURE__*/_react.default.createElement(_StringList.default, {
      list: series.genres,
      separatorType: "comma",
      makeBlock: true
    }), /*#__PURE__*/_react.default.createElement(_StringList.default, {
      list: ratingAndTime,
      separatorType: "pipe",
      makeBlock: true
    })]
  }) : /*#__PURE__*/_react.default.createElement(_ImageCard.default, {
    image: {
      url: (_series$detailImage = series.detailImage) === null || _series$detailImage === void 0 ? void 0 : _series$detailImage.url,
      aspectRatio: (_series$detailImage2 = series.detailImage) === null || _series$detailImage2 === void 0 ? void 0 : _series$detailImage2.aspectRatio
    },
    content: /*#__PURE__*/_react.default.createElement(_Concat.default, {
      list: [typeof series.genres === 'string' ? series.genres : /*#__PURE__*/_react.default.createElement(_StringList.default, {
        list: series.genres,
        separatorType: "comma",
        makeBlock: true
      }), /*#__PURE__*/_react.default.createElement(_StringList.default, {
        list: ratingAndTime,
        separatorType: "pipe",
        makeBlock: true
      })]
    })
  }), /*#__PURE__*/_react.default.createElement(_ShowAboutContent.default, {
    series: series,
    showUpcoming: showUpcoming,
    castStr: castStr,
    type: type,
    nextAirDates: nextAirdates
  })));
}
var _default = exports.default = ShowAboutLayout;